import { Button } from "@/components/ui/button";
import { Sun, Moon, Globe } from "lucide-react";
import cswLogo from "@/assets/csw-logo-new.png";
import { useTheme } from "next-themes";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const Header = () => {
  const { theme, setTheme } = useTheme();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-border/40 bg-background/80 backdrop-blur-xl">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="/" className="flex items-center hover:opacity-80 transition-opacity">
            <img 
              src={cswLogo} 
              alt="CSW - Chill Study Work" 
              className="h-12 w-auto"
            />
          </a>
          
          {/* Right Section: Theme Toggle, Language Switcher, CTA */}
          <div className="flex items-center gap-4">
            {/* Theme Toggle */}
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
              className="w-10 h-10 rounded-lg hover:bg-accent"
            >
              <Sun className="h-5 w-5 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
              <Moon className="absolute h-5 w-5 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
              <span className="sr-only">Toggle theme</span>
            </Button>

            {/* Language Switcher */}
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="icon" className="w-10 h-10 rounded-lg hover:bg-accent">
                  <Globe className="h-5 w-5" />
                  <span className="sr-only">Change language</span>
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-48">
                <DropdownMenuItem asChild>
                  <a href="/" className="cursor-pointer">🇺🇸 English</a>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <a href="/jp/" className="cursor-pointer">🇯🇵 日本語</a>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <a href="/vn/" className="cursor-pointer">🇻🇳 Tiếng Việt</a>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <a href="/cn/" className="cursor-pointer">🇨🇳 简体中文</a>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <a href="/tw/" className="cursor-pointer">🇹🇼 繁體中文</a>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <a href="/kr/" className="cursor-pointer">🇰🇷 한국어</a>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>

            {/* CTA Button */}
            <Button 
              asChild
              className="bg-primary hover:bg-primary/90 text-primary-foreground font-semibold px-6 transition-all hover:scale-105"
            >
              <a href="https://app.csw.live" target="_blank" rel="noopener noreferrer">
                Join Now For Free
              </a>
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};
